import React, { useState, useRef } from 'react';
import { useSources } from 'hooks';
import Avatar from '@material-ui/core/Avatar';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import { IconButton } from '@material-ui/core';
import { MdDownload } from 'react-icons/md';
import { CSVLink } from 'react-csv';

import _ from 'lodash';

import { Table, Tooltip } from 'components';

import UserInteractionProfile from '../UserInteractionProfile';
import { formatDate } from 'utils/time';
import API from 'utils/api';

import styles from './UsersTable.module.scss';

const WaitList = props => {
  const [userData, setUserData] = useState();
  const [userProfileDialog, setUserProfileDialog] = useState(false);
  const [dataReport, setDataReport] = useState([]);
  const [csvLink, setCsvLink] = useState();
  const tableRef = useRef();

  const sources = useSources();

  const { dateFrom, dateTo } = props;

  const columns = [
    {
      title: 'User',
      field: 'name',
      render: rowData => {
        let name = 'Anonymous user';

        if (rowData.type === 'waitlist') {
          const waitListStaus = _.get(rowData, 'waitlist.status', null);
          const phone = _.get(rowData, 'waitlist.phoneNumber', null);
          name = waitListStaus === 'confirmed' ? phone : null;
        }

        if (rowData.name) {
          name = rowData.name;
        }

        return (
          <div className={styles.displayName}>
            <Avatar className={styles.avatar} src={rowData.profile_pic}>
              <PersonOutlineOutlinedIcon />
            </Avatar>
            {name}
          </div>
        );
      },
    },
    {
      title: 'referral from',
      field: 'waitlist.referralCode',
    },
    {
      title: 'Subscribed',
      field: 'createdAt',
      render: rowData => <div>{formatDate(rowData.createdAt)}</div>,
      type: 'date',
      filtering: false,
    },
  ];

  const renderControlPanel = () => {
    return (
      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
        <IconButton onClick={exportCSV}>
          <Tooltip title="Click to export table data" placement="top">
            <MdDownload />
          </Tooltip>
        </IconButton>
      </div>
    );
  };

  const openUserProfileDialog = rowData => {
    setUserProfileDialog(true);
    setUserData(rowData);
  };

  const closeUserProfileDialog = () => {
    setUserProfileDialog(false);
    setUserData(null);
  };

  const exportCSV = () => {
    let filter = {};

    const search = _.get(tableRef, 'current.state.search', '');

    if (search.length > 0) {
      filter.name = search;
    }

    API.getUserInteractions(
      {
        ...filter,
        type: 'waitlist',
      },
      sources
    ).then(({ data }) => {
      if (data && data.docs) {
        const users = data.docs.map(user => {
          let name = 'Anonymous user';

          if (user.type === 'waitlist') {
            const waitListStatus = _.get(user, 'waitlist.status', null);
            const phone = _.get(user, 'waitlist.phoneNumber', null);
            name = waitListStatus === 'confirmed' ? phone : null;
          }

          if (user.name) {
            name = user.name;
          }

          return {
            user: name,
            referral: user.waitlist.referralCode,
            subscribed: user.createdAt,
          };
        });
        setDataReport(users);
        csvLink.link.click();
      }
    });
  };

  const fetchData = ({ pageSize, page, search, sort, filter }) => {
    let query = {};

    if (filter) {
      for (const keyFilter in filter) {
        if (keyFilter === 'name') {
          filter['waitlist.phoneNumber'] = filter[keyFilter];
        } else {
          query[keyFilter] = filter[keyFilter];
        }
      }
    }

    if (search && search.length > 0) {
      query.name = search;
    }

    return API.getUserInteractions(
      {
        type: 'waitlist',
        ...query,
        per_page: pageSize,
        page,
        from: dateFrom,
        to: dateTo,
        sort: sort ? sort : 'createdAt',
      },
      sources
    );
  };

  return (
    <>
      <CSVLink
        data={dataReport}
        filename="data.csv"
        className="hidden"
        ref={r => setCsvLink(r)}
        target="_blank"
      />

      <Table
        title="Users"
        columns={columns}
        data={fetchData}
        rowStyle={() => ({ cursor: 'pointer' })}
        onRowClick={openUserProfileDialog}
        tableRef={tableRef}
        controlPanel={renderControlPanel()}
        filtering
      />

      {userData && (
        <UserInteractionProfile
          userData={userData}
          open={userProfileDialog}
          onClose={closeUserProfileDialog}
        />
      )}
    </>
  );
};

export default WaitList;
